var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegionLondon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-region-london)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 19,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.4 -1.6 L28.4 20.6 M28.4 -1.6 L-2.4 20.6",
    stroke: "#F7FCFF",
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 -0.7 L27 19.7 M27 -0.7 L-1 19.7",
    stroke: "#E31D1C",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0 V19 M0 9.5 H26",
    stroke: "#F7FCFF",
    strokeWidth: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0 V19 M0 9.5 H26",
    stroke: "#E31D1C",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-region-london"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 19,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionLondon);
export default __webpack_public_path__ + "static/media/region-london.80c9574103a1b868e8182b2fda680eda.svg";
export { ForwardRef as ReactComponent };